import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";

import { Translate, I18n } from "react-redux-i18n";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

import "../../../styles/components/chargers/modals/AddTariff.scss";

class TariffModal extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,
      tariffType: "",
      billingType: "",
    };

    this.handleOnChangeTariffType = this.handleOnChangeTariffType.bind(this);
    this.handleOnChangeBillingType = this.handleOnChangeBillingType.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.selectedTariff &&
      (prevProps?.selectedTariff?.billingType !==
        this.props.selectedTariff.billingType ||
        prevProps?.selectedTariff?.tariffType !==
          this.props.selectedTariff.tariffType)
    ) {
      this.safeSetState({
        tariffType: this.props.selectedTariff.tariffType,
        billingType: this.props.selectedTariff.billingType,
      });
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  handleOnSubmit(e) {
    e.preventDefault();
    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        this.props.onSubmit(form);
      }
    });
  }

  handleOnChangeTariffType(e) {
    this.safeSetState({
      tariffType: e.target.value,
    });
  }

  handleOnChangeBillingType(e) {
    this.safeSetState({
      billingType: e.target.value,
    });
  }

  resetState() {
    this.safeSetState({
      validated: false,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <Modal
        id="addTariff"
        show={this.props.show}
        onHide={this.props.onHide}
        onExited={this.resetState}
        centered
      >
        <Modal.Header>
          <Modal.Title>
            <Translate
              value={
                this.props.mode === "add"
                  ? "tariffs_addTariff"
                  : "tariffs_editTariff"
              }
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            id="add-tariff"
            noValidate
            validated={this.state.validated}
            onSubmit={this.handleOnSubmit}
          >
            <Form.Group className="form-field" controlId="tariffName">
              <Form.Label>
                <Translate value="addTariff_name" />
              </Form.Label>
              <Form.Control
                type="text"
                name="tariffName"
                placeholder={I18n.t("addTariff_tariffNameExample")}
                defaultValue={
                  this.props.selectedTariff && this.props.selectedTariff.name
                }
                required
              />
              <Form.Control.Feedback type="invalid">
                <Translate value="addTariff_invalidTariffName" />
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-field" controlId="tariffType">
              <Form.Label>
                <Translate value="addTariff_tariffType" />
              </Form.Label>
              <div className="select">
                <Form.Control
                  as="select"
                  name="tariffType"
                  value={this.state.tariffType}
                  onChange={this.handleOnChangeTariffType}
                  required
                >
                  <option value="" disabled hidden>
                    {I18n.t("addTariff_tariffTypeSelect")}
                  </option>
                  <option value="Time Based">
                    {I18n.t("addTariff_timeBased")}
                  </option>
                  <option value="Energy Based">
                    {I18n.t("addTariff_energyBased")}
                  </option>
                </Form.Control>
              </div>
            </Form.Group>

            <Form.Group className="form-field" controlId="tariffChargeBilling">
              <Form.Label>
                <Translate value="addTariff_chargeBilling" />
              </Form.Label>
              <div className="select">
                <Form.Control
                  as="select"
                  name="tariffBillingType"
                  value={this.state.billingType}
                  onChange={this.handleOnChangeBillingType}
                  required
                >
                  <option value="" disabled hidden>
                    {I18n.t("addTariff_tariffTypeSelect")}
                  </option>
                  <option value="billingTypeNotApplicable">
                    {I18n.t("addTariff_billingTypeNotApplicable")}
                  </option>
                  <option value="billingTypeForImportingCosts">
                    {I18n.t("addTariff_billingTypeForImportingCosts")}
                  </option>
                  <option
                    value="billingTypeForBilling"
                    disabled={
                      !this.props.userPackage?.billingTariffEnabled
                    }
                  >
                    {I18n.t("addTariff_billingTypeForBilling")}
                  </option>
                </Form.Control>
              </div>
            </Form.Group>

            <Form.Group className="form-field">
              <Form.Label>
                <Translate value="addTariff_tariff" />
              </Form.Label>
              <InputGroup className="tariff-input-container">
                <div className="tariff-component-container">
                  <Form.Control
                    type="number"
                    name="tariffBooking"
                    min="0"
                    step="0.0001"
                    defaultValue={
                      this.props.selectedTariff &&
                      this.props.selectedTariff.tariff.bookingAmount.value
                    }
                    placeholder={`1${this.props.preferences.currency}`}
                    disabled
                  />
                  <Form.Label>
                    <Translate value="addTariff_booking" />
                    {` (${this.props.preferences.currency})`}
                  </Form.Label>
                </div>
                <div className="tariff-component-container">
                  <Form.Control
                    type="number"
                    name="tariffActivationFee"
                    min="0"
                    step="0.0001"
                    defaultValue={
                      this.props.selectedTariff &&
                      this.props.selectedTariff.tariff.activationFee
                    }
                    placeholder={`0.5${this.props.preferences.currency}`}
                    required
                  />
                  <Form.Label>
                    <Translate value="addTariff_activationFee" />
                    {` (${this.props.preferences.currency})`}
                  </Form.Label>
                </div>
                <div className="tariff-component-container">
                  <Form.Control
                    type="number"
                    name="tariffCharging"
                    min="0"
                    step="0.0001"
                    defaultValue={
                      this.props.selectedTariff &&
                      this.props.selectedTariff.tariff.chargingAmount.value
                    }
                    placeholder={
                      " " +
                      this.props.preferences.currency +
                      " " +
                      (this.state.tariffType !== ""
                        ? this.state.tariffType === "Energy Based"
                          ? "/ kWh"
                          : "/ min"
                        : "/ min")
                    }
                    required
                  />
                  <Form.Label>
                    <Translate value="addTariff_charging" />
                    {" " +
                      this.props.preferences.currency +
                      " " +
                      (this.state.tariffType !== ""
                        ? this.state.tariffType === "Energy Based"
                          ? "/ kWh"
                          : "/ min"
                        : "/ min")}
                  </Form.Label>
                </div>
                <div className="tariff-component-container">
                  <Form.Control
                    type="number"
                    name="tariffParkingDuringCharging"
                    min="0"
                    step="0.0001"
                    defaultValue={
                      this.props.selectedTariff &&
                      this.props.selectedTariff.tariff
                        .parkingDuringChargingAmount.value
                    }
                    placeholder={
                      " " + this.props.preferences.currency + " / min"
                    }
                    required
                  />
                  <Form.Label>
                    <Translate value="addTariff_parkingDuringCharging" />
                    {" " + this.props.preferences.currency + " / min"}
                  </Form.Label>
                </div>
                <div className="tariff-component-container">
                  <Form.Control
                    type="text"
                    name="tariffComission"
                    value={
                      this.state.billingType &&
                      this.state.billingType === "billingTypeForBilling"
                        ? "10%"
                        : I18n.t("addTariff_comissionNA")
                    }
                    disabled
                  />
                  <Form.Label>
                    <Translate value="addTariff_comission" />
                  </Form.Label>
                </div>
              </InputGroup>
              {this.state.billingType &&
                this.state.billingType === "billingTypeForBilling" && (
                  <div className="comission-info">
                    <Translate value="addTariff_comissionInfo" />
                  </div>
                )}
            </Form.Group>
            <Form.Group className="form-field">
              <Form.Label>
                <Translate value="addTariff_adviser" />
              </Form.Label>
              <div className="adviser-component">
                <Translate value="addTariff_booking" />
                <span>{`0${this.props.preferences.separator}50${this.props.preferences.currency} - 2${this.props.preferences.currency}`}</span>
              </div>
              <div className="adviser-component">
                <Translate value="addTariff_activationFee" />
                <span>{`0${this.props.preferences.separator}50${this.props.preferences.currency} - 2${this.props.preferences.currency}`}</span>
              </div>
              <div className="adviser-component">
                <Translate value="addTariff_charging" />
                <span>{`0${this.props.preferences.separator}15${this.props.preferences.currency} - 0${this.props.preferences.separator}50${this.props.preferences.currency}`}</span>
              </div>
              <div className="adviser-component">
                <Translate value="addTariff_parkingDuringCharging" />
                <span>{`0${this.props.preferences.separator}10${this.props.preferences.currency} - 0${this.props.preferences.separator}45${this.props.preferences.currency}`}</span>
              </div>
              <div className="adviser-component">
                <Translate value="addTariff_parking" />
                <span>{`0${this.props.preferences.separator}10${this.props.preferences.currency} - 0${this.props.preferences.separator}45${this.props.preferences.currency}`}</span>
              </div>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button type="submit" form="add-tariff">
            <Translate
              value={
                this.props.mode === "add" ? "addTariff_add" : "addTariff_edit"
              }
            />
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  preferences: state.account.preferences,
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, null)(TariffModal);
